// extracted by mini-css-extract-plugin
export default {"wrapper":"PricesPageNew-module--wrapper--UnZuz"};